import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';
import Template1 from '../FreeWebsite/../Template1/Template1';
import Template2 from '../FreeWebsite/../Template2/Template2';
import Template3 from '../FreeWebsite/../Template3/Template3';
import Template4 from '../FreeWebsite/../Template4/Template4';
import Template5 from '../FreeWebsite/../Template5/Template5';
import Template6 from '../FreeWebsite/../Template6/Template6';
import Template7 from '../FreeWebsite/../Template7/Template7';

function renderTemplate(id, real) {
  const n = Number(id);
  if (n === 1) return <Template1 templateData={real} />;
  if (n === 2) return <Template2 templateData={real} />;
  if (n === 3) return <Template3 templateData={real} />;
  if (n === 4) return <Template4 templateData={real} />;
  if (n === 5) return <Template5 templateData={real} />;
  if (n === 6) return <Template6 templateData={real} />;
  if (n === 7) return <Template7 templateData={real} />;
  return <Template1 templateData={real} />;
}

export default function BusinessView() {
  const { slug } = useParams();
  const [listing, setListing] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE_URL}/directory/listing/${encodeURIComponent(slug)}`);
        if (!res.ok) throw new Error(`Listing not found (${res.status})`);
        const j = await res.json();
        setListing(j);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) return <div style={{ padding: 24 }}>Loading…</div>;
  if (error) return <div style={{ padding: 24, color: '#b00020' }}>Error: {error}</div>;
  if (!listing) return <div style={{ padding: 24 }}>Not found</div>;

  // If listing has template_data and template_id, render the template directly
  if (listing.template_data && listing.template_id) {
    try {
      const templateData = typeof listing.template_data === 'string' 
        ? JSON.parse(listing.template_data) 
        : listing.template_data;
      const real = templateData?.template?.realData || templateData?.templateData || templateData?.realData || {};
      
      if (real && Object.keys(real).length > 0) {
        return (
          <div style={{ minHeight: '100vh', background: '#fff' }}>
            {renderTemplate(listing.template_id, real)}
          </div>
        );
      }
    } catch (e) {
      console.error('Failed to parse template data:', e);
    }
  }

  // Fallback: if website URL exists and is external, redirect to it
  const website = String(listing.website || '');
  if (website && website !== '' && !website.includes('/live-demo/')) {
    const url = /^https?:\/\//i.test(website) ? website : `https://${website}`;
    window.location.replace(url);
    return <div style={{ padding: 24 }}>Redirecting…</div>;
  }

  // No valid website data found
  return (
    <div style={{ padding: 24 }}>
      <h2>Website Not Available</h2>
      <p>This business listing does not have a website configured yet.</p>
    </div>
  );
}


